import { render } from "./SidebarElement.vue?vue&type=template&id=ae62e5b8"
import script from "./SidebarElement.vue?vue&type=script&lang=js"
export * from "./SidebarElement.vue?vue&type=script&lang=js"

import "./SidebarElement.vue?vue&type=style&index=0&id=ae62e5b8&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__